import { AdvancedSettingsVirtualStepValue } from 'wizards/models/advanced-settings-vm-models';
import { ClusterStepValue } from 'wizards/models/cluster-models';
import { VmwareHyperVBaseModel } from '../base/vmware-hyper-v-base-model';

export class HyperVFormModel extends VmwareHyperVBaseModel {
  advancedSettingsStep: AdvancedSettingsVirtualStepValue = {
    useChangeBlockTracking: false,
    useS3Acceleration: false,
    storageClass: 1,
    syntheticFull: true,
    valid: true
  };
  AvailableMachinePlans: any[] = [];

  clusterStep?: ClusterStepValue;

  constructor(
    public isUnix = false,
    public isNBF = false,
    public needClusterStep = false
  ) {
    super(isUnix, isNBF);

    if (needClusterStep) {
      this.clusterStep = {
        clusterBackup: false,
        login: '',
        password: '',
        remember: false,
        skipCredentials: false,
        valid: true
      };
    }
  }
}
